module.exports = __webpack_public_path__ + "assets/img/hbbg1.e13dc4b0.png";